(function() {
  // 预加载图片的工具函数
  function preloadImages(urls) {
    return Promise.all(urls.map(function(url) {
      return new Promise(function(resolve) {
        var img = new Image();
        img.onload = function() { resolve(url); };
        img.onerror = function() { resolve(url); }; // 失败也继续
        img.src = url;
      });
    }));
  }

  // 为每个产品卡片构建悬停轮播
  async function initHoverGallery(card) {
    var imgWrapper = card.querySelector('.indiv-product__image-wrapper');
    if (!imgWrapper) return;

    var jsonScript = card.querySelector('.product-grid-json');
    if (!jsonScript) return;

    var productData;
    try {
      productData = JSON.parse(jsonScript.textContent);
    } catch (e) {
      return;
    }

    var media = productData.media;
    if (!media || media.length < 3) return; // 不足三张图不启用

    // 提取前三张图的 URL（使用 600x 尺寸）
    var imageUrls = media.slice(0, 3).map(function(m) {
      // Shopify CDN 的 URL 通常形如 //cdn.shopify.com/.../image.jpg?v=123
      // 我们在后面追加 _600x 来获得 600px 宽度
      return m.preview_image.src.replace(/\.(jpg|png|webp|jpeg)(\?v=\d+)?$/i, '_600x.$1');
    });

    // 预加载所有三张图片，确保切换时不会闪烁
    await preloadImages(imageUrls);

    // 隐藏原主题的图片（但保留其占位，避免布局抖动）
    var originalImg = imgWrapper.querySelector('img');
    if (originalImg) {
      originalImg.style.visibility = 'hidden'; // 隐藏但保留空间
    }

    // 创建我们的轮播容器
    var stack = document.createElement('div');
    stack.className = 'hover-image-stack';
    stack.style.cssText = 'position:absolute;top:0;left:0;width:100%;height:100%;z-index:2;';

    // 创建三张图片，全部绝对定位重叠
    for (var i = 0; i < 3; i++) {
      var img = document.createElement('img');
      img.src = imageUrls[i];
      img.alt = '';
      img.style.cssText = 'position:absolute;top:0;left:0;width:100%;height:100%;object-fit:cover;opacity:' + (i === 0 ? '1' : '0') + ';transition:opacity 0.5s ease;';
      stack.appendChild(img);
    }

    imgWrapper.style.position = 'relative'; // 确保容器是相对定位
    imgWrapper.appendChild(stack);

    // 悬停动画控制
    var currentIndex = 0;
    var intervalId = null;
    var imgs = stack.querySelectorAll('img');

    function showImage(index) {
      for (var j = 0; j < imgs.length; j++) {
        imgs[j].style.opacity = (j === index) ? '1' : '0';
      }
    }

    card.addEventListener('mouseenter', function() {
      if (intervalId) return; // 已经在轮播中
      currentIndex = 1; // 先切换到第二张（剖面图）
      showImage(currentIndex);
      intervalId = setInterval(function() {
        currentIndex = (currentIndex + 1) % 3; // 0 → 1 → 2 → 0
        showImage(currentIndex);
      }, 2000); // 每2秒切换
    });

    card.addEventListener('mouseleave', function() {
      clearInterval(intervalId);
      intervalId = null;
      showImage(0); // 恢复第一张
    });
  }

  // 页面加载后初始化所有产品卡片
  document.addEventListener('DOMContentLoaded', function() {
    var cards = document.querySelectorAll('.indiv-product');
    cards.forEach(function(card) {
      initHoverGallery(card);
    });
  });
})();